import React, { useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Radio
} from "antd";
import moment from "moment";

import { FormContainer, DatePicker } from "../../../../../../shared";

const { Item, useForm } = Form;

export const ResearchesModal = ({
  visible = false,
  onCancel,
  onConfirm,
  research = {}
}) => {
  const [form] = Form.useForm();
  const validationMessages = {
    required: "El campo '${label}' es requerido."
  };

  useEffect(() => {
    form.resetFields();
  }, [visible]);

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      onConfirm({
        ...research,
        ...values
      });
    } catch (error) {
      // TODO: Report to bugsnag
    }
  };

  return (
    <Modal
      forceRender
      style={{ width: "600px" }}
      closable
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          type="primary"
          onClick={handleConfirm}>
          Guardar
        </Button>,
        <Button
          onClick={onCancel}>
          Cancelar
        </Button>
      ]}
      title="Investigación o publicación">
      <FormContainer>
        <Form
          form={form}
          layout="vertical"
          validateMessages={validationMessages}>
          <Item
            initialValue={research.type}
            name="type"
            label="Tipo"
            rules={[{ required: true }]}>
            <Radio.Group>
              <Radio value="RESEARCH">Investigación</Radio>
              <Radio value="PUBLISHING">Publicación</Radio>
            </Radio.Group>
          </Item>
          <Item
            initialValue={research.title}
            name="title"
            label="Titulo"
            rules={[{ required: true }]}>
            <Input />
          </Item>
          <Item
            initialValue={research?.institutionName}
            name="institutionName"
            label="Institución"
            rules={[{ required: true }]}>
            <Input />
          </Item>
          <Item
            initialValue={research?.publishedDate ?
              moment(research.publishedDate) : null}
            name="publishedDate"
            label="Fecha"
            rules={[{ required: true }]}>
            <DatePicker />
          </Item>
        </Form>
      </FormContainer>
    </Modal>
  );
};
